import { useEffect, useState } from 'react';

// 00:17:34 — restarts automatically when it reaches zero
const DURATION_SECONDS = 17 * 60 + 34;
const START = Date.now();

function getRemaining(): number {
  const elapsed = Math.floor((Date.now() - START) / 1000);
  return DURATION_SECONDS - (elapsed % DURATION_SECONDS);
}

export function useLoopingCountdown() {
  const [remaining, setRemaining] = useState<number>(getRemaining);

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 1000);
    return () => window.clearInterval(id);
  }, []);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;
  const pad = (n: number) => String(n).padStart(2, '0');

  return { hours: pad(hours), minutes: pad(minutes), seconds: pad(seconds) };
}
